import React from 'react';
import paginationNext from '../assets/images/pagination-next.svg';

export default () => {
  return <img src={paginationNext} alt="Next Page" />;
};
